import { Fade } from "react-awesome-reveal";
import Logo from "../../../../assets/images/Bodybon-Logo.png";
import Profile from "../../../../assets/icons/profile.png";
import Birthday from "../../../../assets/icons/birthday.png";
import Calendar from "../../../../assets/icons/calendar.png";
import Height from "../../../../assets/icons/height.png";
import Weight from "../../../../assets/icons/weight.png";
import TestType from "../../../../assets/icons/test-type.png";
import TestButton from "../../testCommon/TestButton";
import {
  formateDateToJalali,
  genderConverter,
} from "../../../../utils/Functions";

const TestIntro = ({ testInfo, testResults }: any) => {
  const is_pro = testInfo.is_pro_analysis;

  const testData = [
    {
      icon: Profile,
      title: "آزمایش‌دهنده:",
      data: testInfo?.name || "",
      is_basic: true,
    },
    {
      icon: TestType,
      title: "جنسیت:",
      data: genderConverter(testInfo.gender),
      is_basic: true,
    },
    {
      icon: Birthday,
      title: "تاریخ تولد:",
      data: testInfo?.birth_day
        ? formateDateToJalali(testInfo?.birth_day)
        : "-",
      is_basic: true,
    },
    {
      icon: Calendar,
      title: "تاریخ انجام آزمایش:",
      data: testInfo?.test_date
        ? formateDateToJalali(testInfo?.test_date)
        : "-",
      is_basic: true,
    },
    {
      icon: Height,
      title: "قد:",
      data: testInfo?.height ? `${testInfo.height} سانتی‌متر` : "-",
      is_basic: false,
    },
    {
      icon: Weight,
      title: "وزن:",
      data: testInfo?.weight ? `${testInfo.weight} کیلوگرم` : "-",
      is_basic: false,
    },
  ];

  return (
    <div>
      <div className="flex lg:flex-row flex-col">
        <Fade triggerOnce>
          <div className="relative w-full lg:w-96 h-[380px] border-4 border-white shadow-xl rounded-lg overflow-hidden">
            {testInfo?.files[0]?.url.endsWith(".pdf") ? (
              <embed
                key={testInfo?.files[0]?.url}
                src={`${testInfo?.files[0]?.url}#toolbar=0`}
                type="application/pdf"
                className="absolute left-0 top-0 h-auto w-full"
              />
            ) : (
              <img
                key={testInfo?.files[0]?.url}
                className="absolute left-0 top-0 h-auto w-full"
                src={testInfo?.files[0]?.url}
                alt="Lab test analysis"
              />
            )}

            <div
              className="absolute left-0 top-0 h-full w-full z-[2] "
              style={{
                background: `linear-gradient(0deg, rgba(0, 0, 0, .95) 0%, rgba(0, 0, 0, 0) 100%)`,
              }}
            >
              <div className="absolute bottom-0 left-0 w-full py-3 flex items-center justify-center">
                <img src={Logo} alt="بادی‌بان" className="w-8 ml-3" />
                <p className="text-center text-white font-rokh font-[700] mt-2">
                  {is_pro ? "تحلیل پیشـــرفته " : "تحلیل پـــایه "}
                  بادی‌بان
                </p>
              </div>
            </div>

            <div className="h-6 absolute right-2 top-2 z-[3] bg-pr_primary text-white rounded-full flex items-center justify-center font-rokh font-[700] text-xs px-3 pt-1">
              {testInfo?.files.length} تصویر
            </div>
          </div>
        </Fade>

        <div className="flex-1 lg:pr-10 mt-5 lg:mt-0 flex flex-col">
          <Fade triggerOnce className="flex-1" delay={200}>
            <div
              className={`grid ${
                is_pro ? "lg:grid-cols-3" : "lg:grid-cols-2"
              } grid-cols-1 gap-2 flex-1`}
            >
              {testData.slice(0, is_pro ? 6 : 4).map((testDataItem: any) => (
                <div
                  key={testDataItem.title}
                  className="flex-1 p-3 lg:p-5 lg:py-7 bg-white border-[1px] border-gray-200 rounded-xl flex items-center"
                >
                  <img
                    src={testDataItem.icon}
                    className="w-[60px] lg:w-[70px]"
                  />
                  <div className="flex-1 mr-4">
                    <h6 className="text-sm lg:text-base pt-2 font-[700] font-rokh">
                      {testDataItem.title}
                    </h6>
                    <h5 className="drop-shadow-xl font-bold lg:text-[22px]">
                      {testDataItem.data}
                    </h5>
                  </div>
                </div>
              ))}
            </div>

            {testResults.results.length > 0 ? (
              <div className="mt-3 flex flex-col lg:flex-row items-center justify-between bg-pr_blue rounded-xl p-3">
                <p className="font-rokh mt-2 font-[900] mb-4 lg:mb-0">
                  تحلیل آزمایش شما توسط بادی‌بان آماده شده است
                </p>
                <TestButton title="مشـــاهده" step={2} isInline />
              </div>
            ) : (
              <div className="mt-3 flex flex-col lg:flex-row items-center justify-between bg-pr_blue rounded-xl p-3">
                <p className="font-rokh mt-2 font-[900] mb-4 lg:mb-0">
                  تصویر آزمایش آپلود شده برای استخراج داده‌ها مناسب نبود
                </p>
                <TestButton
                  title="بارگذاری آزمایش جدید"
                  step={2}
                  isNull
                  isInline
                />
              </div>
            )}
            <p className="text-sm w-full mt-2 text-center">
              تحلیل‌های ارائه شده توسط هوش مصنوعی باید به عنوان اطلاعات کمکی در
              نظر گرفته شوند و جایگزین مشاوره مستقیم با پزشکان و متخصصین
              نمی‌شوند.
            </p>
          </Fade>
        </div>
      </div>
    </div>
  );
};

export default TestIntro;
